import { render } from "./B2bPageRemadv.vue?vue&type=template&id=2dc2bdba&scoped=true&lang=pug"
import script from "./B2bPageRemadv.vue?vue&type=script&lang=js"
export * from "./B2bPageRemadv.vue?vue&type=script&lang=js"

import "./B2bPageRemadv.vue?vue&type=style&index=0&id=2dc2bdba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc2bdba"]])

export default __exports__